import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";

import Transitions from "../../utils/Transitions";
import logo from "../../assets/logo.png";

export default function AppHeader() {
  const [showMenu, setShowMenu] = useState(false);

  const { push } = useHistory();

  return (
    <Fragment>
      <header class="absolute inset-x-0  top-0 w-full sticky z-50 bg-white bg-transparent  bg-opacity-50 backdrop-blur backdrop-filter">
        <div class="px-4 mx-auto sm:px-6 lg:px-8">
          <div class="flex items-center justify-between h-16 lg:h-20">
            {/* <div class="hidden flex-shrink-0">
              <a href="#" title="" class="flex">
                <img class="w-auto h-8" src={calbalk} alt="" />
              </a>
            </div> */}
            <div class="flex-shrink-0 lg:ml-3">
              <a href="#" title="#" class="flex">
                <img
                  class="w-auto h-8"
                  src={logo}
                  alt="Tap and Go Bus Tickets"
                />
              </a>
            </div>

            <div class="hidden pl-10 lg:flex lg:items-center lg:justify-center lg:space-x-10">
              <a
                href="#/"
                title=""
                class="text-base text-black transition-all duration-200 hover:text-opacity-80"
              >
                {" "}
                Home{" "}
              </a>

              {/* <a
                href="#/faqs"
                title=""
                class="text-base text-black transition-all duration-200 hover:text-opacity-80"
              >
                {" "}
                Faqs{" "}
              </a> */}
              <a
                href="#/routes"
                title=""
                class="text-base text-black transition-all duration-200 hover:text-opacity-80"
              >
                {" "}
                Routes{" "}
              </a>
              <a
                href="#/terms"
                title=""
                class="text-base text-black transition-all duration-200 hover:text-opacity-80"
              >
                {" "}
                Terms & Conditions{" "}
              </a>
            </div>

            <div class="lg:flex lg:items-center lg:justify-end lg:space-x-6 sm:ml-auto">
              {/* <a
                  href="#"
                  title=""
                  class="hidden text-base text-white transition-all duration-200 lg:inline-flex hover:text-opacity-80"
                >
                  {" "}
                  Log in{" "}
                </a> */}

              <a
                href="#"
                title=""
                class="inline-flex items-center justify-center px-3 sm:px-5 py-2.5 text-sm sm:text-base font-semibold transition-all duration-200 text-black bg-black/20 hover:bg-black/40 focus:bg-black/40 rounded-lg"
                role="button"
              >
                {" "}
                Bus Ticketing{" "}
              </a>
            </div>

            <button
              type="button"
              aria-expanded="false"
              onClick={() => setShowMenu(!showMenu)}
              class="inline-flex p-2 ml-1 text-black transition-all duration-200 rounded-md sm:ml-4 lg:hidden  hover:bg-red-100"
            >
              {/* <!-- Menu open: "hidden", Menu closed: "block" --> */}
              <svg
                class="block w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>

              {/* <!-- Menu open: "block", Menu closed: "hidden" --> */}
              <svg
                class="hidden w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <Transitions
          show={showMenu}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <div
            class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            tabindex="-1"
          >
            <a
              onClick={() => {
                setShowMenu(false);
              }}
              href="#/routes"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
              tabindex="-1"
              id="user-menu-item-2"
            >
              Routes
            </a>
            <a
              onClick={() => {
                setShowMenu(false);
              }}
              href="#/terms"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
              tabindex="-1"
              id="user-menu-item-0"
            >
              Terms
            </a>
            <a
              onClick={() => {
                setShowMenu(false);
              }}
              href="#/faqs"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              role="menuitem"
              tabindex="-1"
              id="user-menu-item-1"
            >
              Faqs
            </a>
          </div>
        </Transitions>
      </header>

      {/* <nav class="bg-white  sticky z-10 top-0 bg-opacity-75  backdrop-blur backdrop-filter  ">
        <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div class="flex justify-between h-16">
            <div class="flex px-2 mx-auto lg:px-0">
              <a href="/">
                <div class="flex-shrink-0 flex items-center ">
               
                  <img
                    class="max-h-16"
                    src="https://vip.itmsgh.com/static/media/calbank.64dea078.png"
                    alt="Hubtel"
                  />

                  <img
                    class="max-h-14"
                    src="data:image/png;base64,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"
                    alt="VIP"
                  />

                  <h1 className="font-bold flex flex-1 text-center ml-5 text-lg text-gray-700">
                    Bus Online Ticket
                  </h1>
                </div>
              </a>
            </div>

         
            <div class="hidden lg:ml-4 lg:flex lg:items-center">
             

              <div class="ml-4 relative flex-shrink-0">
               
             
                <Transitions
                  show={showMenu}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <div
                    class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="user-menu-button"
                    tabindex="-1"
                  >
                    <span
                      href="#"
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-0"
                    >
                      Your Profile
                    </span>
                    <span
                      href="#"
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-1"
                    >
                      Settings
                    </span>
                    <span
                      onClick={() => {
                        setShowMenu(false);
                        cookiesConfig.clearCipher();
                        push("/login");
                      }}
                      //   href="#"
                      class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      role="menuitem"
                      tabindex="-1"
                      id="user-menu-item-2"
                    >
                      Sign out
                    </span>
                  </div>
                </Transitions>
              </div>
            </div>
          </div>
        </div>

        <div class="lg:hidden" id="mobile-menu">
          <Transitions
            show={showMenu}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <div>
              <div class="pt-4 pb-3 border-t border-gray-200">
                <div class="flex items-center px-4">
                  <div class="flex-shrink-0">
                    <img
                      class="h-10 w-10 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixqx=ah3lxr8uqw&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt=""
                    />
                  </div>
                  <div class="ml-3">
                    <div class="text-base font-medium text-gray-800">
                      Tom Cook
                    </div>
                    <div class="text-sm font-medium text-gray-500">
                      tom@example.com
                    </div>
                  </div>
                  <button class="ml-auto flex-shrink-0 bg-white p-1 text-gray-400 rounded-full hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <span class="sr-only">View notifications</span>

                    <svg
                      class="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                  </button>
                </div>
                <div class="mt-3 space-y-1">
                  <a
                    href="#"
                    class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                  >
                    Your Profile
                  </a>
                  <a
                    href="#"
                    class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                  >
                    Settings
                  </a>
                  <a
                    href="#"
                    class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                  >
                    Sign out
                  </a>
                </div>
              </div>
            </div>
          </Transitions>
        </div>
      </nav> */}
    </Fragment>
  );
}
